import React, { Component } from 'react';
//import { convertFromRaw } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import Button from '@material-ui/core/Button';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import { connect } from 'react-redux';
import withStyles from '@material-ui/core/styles/withStyles';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import loadable from "@loadable/component";

//import CommentSection from '../CommentSection/CommentSection'
//import lzwCompress from 'lzwcompress';

const CommentSection = loadable(() => import('../CommentSection/CommentSection'),
  {
    fallback: ""
  }
);



/*

*/ //artocle with text and
const original1 = "How rabbits secretely control the upper echelons of society."
const original2 = "December 14th 2020"
const original3 = "Start typing here....DO NOT edit the title or date, please. "






// {
//     "blocks": [
//         {""}
//         {
//             "key": "cut5j",
//             "text": original2,
//             "type": "header-four",
//             "depth": 0,
//             "inlineStyleRanges": [],
//             "entityRanges": [],
//             "data": {}
//         },
//         {
//             "key": "d812f",
//             "text": original3,
//             "type": "unstyled",
//             "depth": 0,
//             "inlineStyleRanges": [],
//             "entityRanges": [],
//             "data": {}
//         },
//     ],
//     "entityMap": {}
// }

// content = {"blocks":[{"key":"637gr","text":"1000 character article","type":"header-one","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"cut5j","text":"December 20, 2020","type":"header-four","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"d812f","text":"Let's put a tonne of text here. Let's put a tonne of text here. Let's put a tonne of text here. Let's put a tonne of text here. Let's put a tonne of text here. Let's put a tonne of text here. Let's put a tonne of text here. Let's put a tonne of text here. Let's put a tonne of text here. ","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":32,"length":31,"style":"color-rgb(0,0,0)"},{"offset":64,"length":31,"style":"color-rgb(0,0,0)"},{"offset":96,"length":31,"style":"color-rgb(0,0,0)"},{"offset":128,"length":31,"style":"color-rgb(0,0,0)"},{"offset":160,"length":31,"style":"color-rgb(0,0,0)"},{"offset":192,"length":31,"style":"color-rgb(0,0,0)"},{"offset":224,"length":31,"style":"color-rgb(0,0,0)"},{"offset":256,"length":31,"style":"color-rgb(0,0,0)"},{"offset":32,"length":31,"style":"bgcolor-rgb(255,255,255)"},{"offset":64,"length":31,"style":"bgcolor-rgb(255,255,255)"},{"offset":96,"length":31,"style":"bgcolor-rgb(255,255,255)"},{"offset":128,"length":31,"style":"bgcolor-rgb(255,255,255)"},{"offset":160,"length":31,"style":"bgcolor-rgb(255,255,255)"},{"offset":192,"length":31,"style":"bgcolor-rgb(255,255,255)"},{"offset":224,"length":31,"style":"bgcolor-rgb(255,255,255)"},{"offset":256,"length":31,"style":"bgcolor-rgb(255,255,255)"},{"offset":32,"length":31,"style":"fontsize-21"},{"offset":64,"length":31,"style":"fontsize-21"},{"offset":96,"length":31,"style":"fontsize-21"},{"offset":128,"length":31,"style":"fontsize-21"},{"offset":160,"length":31,"style":"fontsize-21"},{"offset":192,"length":31,"style":"fontsize-21"},{"offset":224,"length":31,"style":"fontsize-21"},{"offset":256,"length":31,"style":"fontsize-21"},{"offset":32,"length":31,"style":"fontfamily-Helvetica Neue\", Helvetica, Arial, sans-serif"},{"offset":64,"length":31,"style":"fontfamily-Helvetica Neue\", Helvetica, Arial, sans-serif"},{"offset":96,"length":31,"style":"fontfamily-Helvetica Neue\", Helvetica, Arial, sans-serif"},{"offset":128,"length":31,"style":"fontfamily-Helvetica Neue\", Helvetica, Arial, sans-serif"},{"offset":160,"length":31,"style":"fontfamily-Helvetica Neue\", Helvetica, Arial, sans-serif"},{"offset":192,"length":31,"style":"fontfamily-Helvetica Neue\", Helvetica, Arial, sans-serif"},{"offset":224,"length":31,"style":"fontfamily-Helvetica Neue\", Helvetica, Arial, sans-serif"},{"offset":256,"length":31,"style":"fontfamily-Helvetica Neue\", Helvetica, Arial, sans-serif"}],"entityRanges":[],"data":{}},{"key":"4aqbn","text":"Let's put a tonne of text here. Let's put a tonne of text here. Let's put a tonne of text here. ","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":31,"style":"color-rgb(0,0,0)"},{"offset":32,"length":31,"style":"color-rgb(0,0,0)"},{"offset":64,"length":31,"style":"color-rgb(0,0,0)"},{"offset":0,"length":31,"style":"bgcolor-rgb(255,255,255)"},{"offset":32,"length":31,"style":"bgcolor-rgb(255,255,255)"},{"offset":64,"length":31,"style":"bgcolor-rgb(255,255,255)"},{"offset":0,"length":31,"style":"fontsize-21"},{"offset":32,"length":31,"style":"fontsize-21"},{"offset":64,"length":31,"style":"fontsize-21"},{"offset":0,"length":31,"style":"fontfamily-Helvetica Neue\", Helvetica, Arial, sans-serif"},{"offset":32,"length":31,"style":"fontfamily-Helvetica Neue\", Helvetica, Arial, sans-serif"},{"offset":64,"length":31,"style":"fontfamily-Helvetica Neue\", Helvetica, Arial, sans-serif"}],"entityRanges":[],"data":{}},{"key":"5gegt","text":"Let's put a tonne of text here. ","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":31,"style":"color-rgb(0,0,0)"},{"offset":0,"length":31,"style":"bgcolor-rgb(255,255,255)"},{"offset":0,"length":31,"style":"fontsize-21"},{"offset":0,"length":31,"style":"fontfamily-Helvetica Neue\", Helvetica, Arial, sans-serif"}],"entityRanges":[],"data":{}},{"key":"3vlrk","text":"Let's put a tonne of text here. Let's put a tonne of text here. Let's put a tonne of text here. ","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":31,"style":"color-rgb(0,0,0)"},{"offset":32,"length":31,"style":"color-rgb(0,0,0)"},{"offset":64,"length":31,"style":"color-rgb(0,0,0)"},{"offset":0,"length":31,"style":"bgcolor-rgb(255,255,255)"},{"offset":32,"length":31,"style":"bgcolor-rgb(255,255,255)"},{"offset":64,"length":31,"style":"bgcolor-rgb(255,255,255)"},{"offset":0,"length":31,"style":"fontsize-21"},{"offset":32,"length":31,"style":"fontsize-21"},{"offset":64,"length":31,"style":"fontsize-21"},{"offset":0,"length":31,"style":"fontfamily-Helvetica Neue\", Helvetica, Arial, sans-serif"},{"offset":32,"length":31,"style":"fontfamily-Helvetica Neue\", Helvetica, Arial, sans-serif"},{"offset":64,"length":31,"style":"fontfamily-Helvetica Neue\", Helvetica, Arial, sans-serif"}],"entityRanges":[],"data":{}},{"key":"6h7hg","text":"Let's put a tonne of text here. Let's put a tonne of text here. Let's put a tonne of text here. ","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":31,"style":"color-rgb(0,0,0)"},{"offset":32,"length":31,"style":"color-rgb(0,0,0)"},{"offset":64,"length":31,"style":"color-rgb(0,0,0)"},{"offset":0,"length":31,"style":"bgcolor-rgb(255,255,255)"},{"offset":32,"length":31,"style":"bgcolor-rgb(255,255,255)"},{"offset":64,"length":31,"style":"bgcolor-rgb(255,255,255)"},{"offset":0,"length":31,"style":"fontsize-21"},{"offset":32,"length":31,"style":"fontsize-21"},{"offset":64,"length":31,"style":"fontsize-21"},{"offset":0,"length":31,"style":"fontfamily-Helvetica Neue\", Helvetica, Arial, sans-serif"},{"offset":32,"length":31,"style":"fontfamily-Helvetica Neue\", Helvetica, Arial, sans-serif"},{"offset":64,"length":31,"style":"fontfamily-Helvetica Neue\", Helvetica, Arial, sans-serif"}],"entityRanges":[],"data":{}},{"key":"3df1r","text":"Let's put a tonne of text here. Let's put a tonne of text here. Let's put a tonne of text here. ","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":31,"style":"color-rgb(0,0,0)"},{"offset":32,"length":31,"style":"color-rgb(0,0,0)"},{"offset":64,"length":31,"style":"color-rgb(0,0,0)"},{"offset":0,"length":31,"style":"bgcolor-rgb(255,255,255)"},{"offset":32,"length":31,"style":"bgcolor-rgb(255,255,255)"},{"offset":64,"length":31,"style":"bgcolor-rgb(255,255,255)"},{"offset":0,"length":31,"style":"fontsize-21"},{"offset":32,"length":31,"style":"fontsize-21"},{"offset":64,"length":31,"style":"fontsize-21"},{"offset":0,"length":31,"style":"fontfamily-Helvetica Neue\", Helvetica, Arial, sans-serif"},{"offset":32,"length":31,"style":"fontfamily-Helvetica Neue\", Helvetica, Arial, sans-serif"},{"offset":64,"length":31,"style":"fontfamily-Helvetica Neue\", Helvetica, Arial, sans-serif"}],"entityRanges":[],"data":{}},{"key":"d95uj","text":"const styles = theme => ({\n\n  articleTopDiv: {\n    display: 'flex',\n    justifyContent: 'center',\n    height: '100%',\n    backgroundColor: 'white',\n    margin: 'auto',\n\n    fontSize: '21px',\n\n  },\n  editor: {\n    display: 'flex',\n    height: '100%',\n    backgroundColor: 'white',\n    margin: 'auto',\n\n  },\n  editorSuperWrapper: {\n    display: 'flex',\n    justifyContent: 'center',\n    height: '100%',\n    backgroundColor: 'white',\n    margin: 'auto',\n    marginTop: '0px',\n    fontSize: '21px',\n  },\n  wrapper: {\n    height: '100%',\n  },\n\n\n\n\n}); ","type":"code","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"9n4kf","text":"And then some more text here, and finally an image:","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"b90kh","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"4pk8g","text":" ","type":"atomic","depth":0,"inlineStyleRanges":[],"entityRanges":[{"offset":0,"length":1,"key":0}],"data":{}},{"key":"fbsr4","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"a6lsb","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{"0":{"type":"IMAGE","mutability":"MUTABLE","data":{"src":"https://s.imgur.com/images/logo-1200-630.jpg?2","height":"auto","width":"auto"}}}}

// let content = {
//   "blocks":[
// {
// "key":"637gr",
// "text":"1000 character article",
// "type":"header-one",
// "depth":0,
// "inlineStyleRanges":[
// ],
// "entityRanges":[
// ],
// "data":{
// }
// },
// {
// "key":"cut5j",
// "text":"December 20, 2020",
// "type":"header-four",
// "depth":0,
// "inlineStyleRanges":[
// ],
// "entityRanges":[
// ],
// "data":{
// }
// },
// {
// "key":"d812f",
// "text":"",
// "type":"unstyled",
// "depth":0,
// "inlineStyleRanges":[
// {
// "offset":32,
// "length":31,
// "style":"color-rgb(0,0,0)"
// },
// {
// "offset":64,
// "length":31,
// "style":"color-rgb(0,0,0)"
// },
// {
// "offset":96,
// "length":31,
// "style":"color-rgb(0,0,0)"
// },
// {
// "offset":128,
// "length":31,
// "style":"color-rgb(0,0,0)"
// },
// {
// "offset":160,
// "length":31,
// "style":"color-rgb(0,0,0)"
// },
// {
// "offset":192,
// "length":31,
// "style":"color-rgb(0,0,0)"
// },
// {
// "offset":224,
// "length":31,
// "style":"color-rgb(0,0,0)"
// },
// {
// "offset":256,
// "length":31,
// "style":"color-rgb(0,0,0)"
// },
// {
// "offset":32,
// "length":31,
// "style":"bgcolor-rgb(255,255,255)"
// },
// {
// "offset":64,
// "length":31,
// "style":"bgcolor-rgb(255,255,255)"
// },
// {
// "offset":96,
// "length":31,
// "style":"bgcolor-rgb(255,255,255)"
// },
// {
// "offset":128,
// "length":31,
// "style":"bgcolor-rgb(255,255,255)"
// },
// {
// "offset":160,
// "length":31,
// "style":"bgcolor-rgb(255,255,255)"
// },
// {
// "offset":192,
// "length":31,
// "style":"bgcolor-rgb(255,255,255)"
// },
// {
// "offset":224,
// "length":31,
// "style":"bgcolor-rgb(255,255,255)"
// },
// {
// "offset":256,
// "length":31,
// "style":"bgcolor-rgb(255,255,255)"
// },
// {
// "offset":32,
// "length":31,
// "style":"fontsize-21"
// },
// {
// "offset":64,
// "length":31,
// "style":"fontsize-21"
// },
// {
// "offset":96,
// "length":31,
// "style":"fontsize-21"
// },
// {
// "offset":128,
// "length":31,
// "style":"fontsize-21"
// },
// {
// "offset":160,
// "length":31,
// "style":"fontsize-21"
// },
// {
// "offset":192,
// "length":31,
// "style":"fontsize-21"
// },
// {
// "offset":224,
// "length":31,
// "style":"fontsize-21"
// },
// {
// "offset":256,
// "length":31,
// "style":"fontsize-21"
// },
// {
// "offset":32,
// "length":31,
// "style":"fontfamily-Helvetica Neue\", Helvetica, Arial, sans-serif"
// },
// {
// "offset":64,
// "length":31,
// "style":"fontfamily-Helvetica Neue\", Helvetica, Arial, sans-serif"
// },
// {
// "offset":96,
// "length":31,
// "style":"fontfamily-Helvetica Neue\", Helvetica, Arial, sans-serif"
// },
// {
// "offset":128,
// "length":31,
// "style":"fontfamily-Helvetica Neue\", Helvetica, Arial, sans-serif"
// },
// {
// "offset":160,
// "length":31,
// "style":"fontfamily-Helvetica Neue\", Helvetica, Arial, sans-serif"
// },
// {
// "offset":192,
// "length":31,
// "style":"fontfamily-Helvetica Neue\", Helvetica, Arial, sans-serif"
// },
// {
// "offset":224,
// "length":31,
// "style":"fontfamily-Helvetica Neue\", Helvetica, Arial, sans-serif"
// },
// {
// "offset":256,
// "length":31,
// "style":"fontfamily-Helvetica Neue\", Helvetica, Arial, sans-serif"
// }
// ],
// "entityRanges":[
// ],
// "data":{
// }
// },
// {
// "key":"4aqbn",
// "text":"",
// "type":"unstyled",
// "depth":0,
// "inlineStyleRanges":[
// {
// "offset":0,
// "length":31,
// "style":"color-rgb(0,0,0)"
// },
// {
// "offset":32,
// "length":31,
// "style":"color-rgb(0,0,0)"
// },
// {
// "offset":64,
// "length":31,
// "style":"color-rgb(0,0,0)"
// },
// {
// "offset":0,
// "length":31,
// "style":"bgcolor-rgb(255,255,255)"
// },
// {
// "offset":32,
// "length":31,
// "style":"bgcolor-rgb(255,255,255)"
// },
// {
// "offset":64,
// "length":31,
// "style":"bgcolor-rgb(255,255,255)"
// },
// {
// "offset":0,
// "length":31,
// "style":"fontsize-21"
// },
// {
// "offset":32,
// "length":31,
// "style":"fontsize-21"
// },
// {
// "offset":64,
// "length":31,
// "style":"fontsize-21"
// },
// {
// "offset":0,
// "length":31,
// "style":"fontfamily-Helvetica Neue\", Helvetica, Arial, sans-serif"
// },
// {
// "offset":32,
// "length":31,
// "style":"fontfamily-Helvetica Neue\", Helvetica, Arial, sans-serif"
// },
// {
// "offset":64,
// "length":31,
// "style":"fontfamily-Helvetica Neue\", Helvetica, Arial, sans-serif"
// }
// ],
// "entityRanges":[
// ],
// "data":{
// }
// },
// {
// "key":"5gegt",
// "text":"",
// "type":"unstyled",
// "depth":0,
// "inlineStyleRanges":[
// {
// "offset":0,
// "length":31,
// "style":"color-rgb(0,0,0)"
// },
// {
// "offset":0,
// "length":31,
// "style":"bgcolor-rgb(255,255,255)"
// },
// {
// "offset":0,
// "length":31,
// "style":"fontsize-21"
// },
// {
// "offset":0,
// "length":31,
// "style":"fontfamily-Helvetica Neue\", Helvetica, Arial, sans-serif"
// }
// ],
// "entityRanges":[
// ],
// "data":{
// }
// },
// {
// "key":"3vlrk",
// "text":"",
// "type":"unstyled",
// "depth":0,
// "inlineStyleRanges":[
// {
// "offset":0,
// "length":31,
// "style":"color-rgb(0,0,0)"
// },
// {
// "offset":32,
// "length":31,
// "style":"color-rgb(0,0,0)"
// },
// {
// "offset":64,
// "length":31,
// "style":"color-rgb(0,0,0)"
// },
// {
// "offset":0,
// "length":31,
// "style":"bgcolor-rgb(255,255,255)"
// },
// {
// "offset":32,
// "length":31,
// "style":"bgcolor-rgb(255,255,255)"
// },
// {
// "offset":64,
// "length":31,
// "style":"bgcolor-rgb(255,255,255)"
// },
// {
// "offset":0,
// "length":31,
// "style":"fontsize-21"
// },
// {
// "offset":32,
// "length":31,
// "style":"fontsize-21"
// },
// {
// "offset":64,
// "length":31,
// "style":"fontsize-21"
// },
// {
// "offset":0,
// "length":31,
// "style":"fontfamily-Helvetica Neue\", Helvetica, Arial, sans-serif"
// },
// {
// "offset":32,
// "length":31,
// "style":"fontfamily-Helvetica Neue\", Helvetica, Arial, sans-serif"
// },
// {
// "offset":64,
// "length":31,
// "style":"fontfamily-Helvetica Neue\", Helvetica, Arial, sans-serif"
// }
// ],
// "entityRanges":[
// ],
// "data":{
// }
// },
// {
// "key":"6h7hg",
// "text":"",
// "type":"unstyled",
// "depth":0,
// "inlineStyleRanges":[
// {
// "offset":0,
// "length":31,
// "style":"color-rgb(0,0,0)"
// },
// {
// "offset":32,
// "length":31,
// "style":"color-rgb(0,0,0)"
// },
// {
// "offset":64,
// "length":31,
// "style":"color-rgb(0,0,0)"
// },
// {
// "offset":0,
// "length":31,
// "style":"bgcolor-rgb(255,255,255)"
// },
// {
// "offset":32,
// "length":31,
// "style":"bgcolor-rgb(255,255,255)"
// },
// {
// "offset":64,
// "length":31,
// "style":"bgcolor-rgb(255,255,255)"
// },
// {
// "offset":0,
// "length":31,
// "style":"fontsize-21"
// },
// {
// "offset":32,
// "length":31,
// "style":"fontsize-21"
// },
// {
// "offset":64,
// "length":31,
// "style":"fontsize-21"
// },
// {
// "offset":0,
// "length":31,
// "style":"fontfamily-Helvetica Neue\", Helvetica, Arial, sans-serif"
// },
// {
// "offset":32,
// "length":31,
// "style":"fontfamily-Helvetica Neue\", Helvetica, Arial, sans-serif"
// },
// {
// "offset":64,
// "length":31,
// "style":"fontfamily-Helvetica Neue\", Helvetica, Arial, sans-serif"
// }
// ],
// "entityRanges":[
// ],
// "data":{
// }
// },
// {
// "key":"3df1r",
// "text":"",
// "type":"unstyled",
// "depth":0,
// "inlineStyleRanges":[
// {
// "offset":0,
// "length":31,
// "style":"color-rgb(0,0,0)"
// },
// {
// "offset":32,
// "length":31,
// "style":"color-rgb(0,0,0)"
// },
// {
// "offset":64,
// "length":31,
// "style":"color-rgb(0,0,0)"
// },
// {
// "offset":0,
// "length":31,
// "style":"bgcolor-rgb(255,255,255)"
// },
// {
// "offset":32,
// "length":31,
// "style":"bgcolor-rgb(255,255,255)"
// },
// {
// "offset":64,
// "length":31,
// "style":"bgcolor-rgb(255,255,255)"
// },
// {
// "offset":0,
// "length":31,
// "style":"fontsize-21"
// },
// {
// "offset":32,
// "length":31,
// "style":"fontsize-21"
// },
// {
// "offset":64,
// "length":31,
// "style":"fontsize-21"
// },
// {
// "offset":0,
// "length":31,
// "style":"fontfamily-Helvetica Neue\", Helvetica, Arial, sans-serif"
// },
// {
// "offset":32,
// "length":31,
// "style":"fontfamily-Helvetica Neue\", Helvetica, Arial, sans-serif"
// },
// {
// "offset":64,
// "length":31,
// "style":"fontfamily-Helvetica Neue\", Helvetica, Arial, sans-serif"
// }
// ],
// "entityRanges":[
// ],
// "data":{
// }
// },
// {
// "key":"d95uj",
// "text":"",
// "type":"code",
// "depth":0,
// "inlineStyleRanges":[
// ],
// "entityRanges":[
// ],
// "data":{
// }
// },
// {
// "key":"9n4kf",
// "text":"",
// "type":"unstyled",
// "depth":0,
// "inlineStyleRanges":[
// ],
// "entityRanges":[
// ],
// "data":{
// }
// },
// {
// "key":"b90kh",
// "text":"",
// "type":"unstyled",
// "depth":0,
// "inlineStyleRanges":[
// ],
// "entityRanges":[
// ],
// "data":{
// }
// },
// {
// "key":"4pk8g",
// "text":" ",
// "type":"atomic",
// "depth":0,
// "inlineStyleRanges":[
// ],
// "entityRanges":[
// {
// "offset":0,
// "length":1,
// "key":0
// }
// ],
// "data":{
// }
// },
// {
// "key":"fbsr4",
// "text":"",
// "type":"unstyled",
// "depth":0,
// "inlineStyleRanges":[
// ],
// "entityRanges":[
// ],
// "data":{
// }
// },
// {
// "key":"a6lsb",
// "text":"",
// "type":"unstyled",
// "depth":0,
// "inlineStyleRanges":[
// ],
// "entityRanges":[
// ],
// "data":{
// }
// }
// ],
// "entityMap":{
// "0":{
// "type":"IMAGE",
// "mutability":"MUTABLE",
// "data":{
// "src":"https://s.imgur.com/images/logo-1200-630.jpg?2",
// "height":"auto",
// "width":"auto"
// }
// }
// }
// }



// const commontypes = { //common types from most frequent to non frequent.
//   "1" :
//           {
//               "key": "REPLACEME",
//               "text": "REPLACEME",
//               "type": "unstyled",
//               "depth": 0,
//               "inlineStyleRanges": [],
//               "entityRanges": [],
//               "data": {}
//           },
//
//   "2":    {
//              "key":"REPLACEME",
//              "text":"REPLACEME",
//              "type":"unordered-list-item",
//              "depth":0,
//              "inlineStyleRanges":[
//
//              ],
//              "entityRanges":[
//
//              ],
//              "data":{
//
//              }
//            },
//   "3":   {
//
//          "key":"REPLACEME",
//          "text":"REPLACEME",
//          "type":"code",
//          "depth":0,
//          "inlineStyleRanges":[
//
//          ],
//          "entityRanges":[
//
//          ],
//          "data":{
//
//          }
//       },
//   "4":   {
//         "key":"84cu1",
//         "text":"",
//         "type":"unstyled",
//         "depth":0,
//         "inlineStyleRanges":[
//
//         ],
//         "entityRanges":[
//
//         ],
//         "data":{
//
//         }
//      }
// }


// for(let x = 0; x < content.blocks.length; x++)
// {
//   if(content.)
// }


const styles = theme => ({

  // articleTopDiv: {
  //   display: 'flex',
  //   justifyContent: 'center',
  //   height: '100%',
  //   backgroundColor: 'white',
  //   margin: 'auto',
  //
  //   fontSize: '21px',
  //
  // },

  classForButtons: {

    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    paddingBottom: '1em'
  },
  editor: {
    display: 'flex',
    height: '100%',
    backgroundColor: 'white',
    margin: 'auto',

  },
  outerdivEditorComponent:{
    paddingBottom: "3em",
    backgroundColor: 'white',
    [theme.breakpoints.down('sm')]: {
      "backgroundColor":'#000011',
    }
  },
  outerDivForBackgroundColor:{
    backgroundColor: "white",
  },
  outerDivForEditorForMargins:{
    marginLeft: "10%",
    marginRight: "10%"
  },
  wrapper: {
    height: '100%',
    marginBottom: '10em'
  },




});

export class EditorComponent extends Component {
  constructor(props) {
    super(props);


const { savedEditor } = this.props;

    let content = { // ACTUAL ONE!!! REAL ONE
        "blocks": [
            {
                "key": "637gr",
                "text": original1,
                "type": "header-one",
                "depth": 0,
                "inlineStyleRanges": [],
                "entityRanges": [],
                "data": {}
            },
            {
                "key": "cut5j",
                "text": original2,
                "type": "header-four",
                "depth": 0,
                "inlineStyleRanges": [],
                "entityRanges": [],
                "data": {}
            }
        ],
        "entityMap": {}
    }


// content = {
//
//    "blocks":[
//      {},
//      {},
//       {
//          "key":"d812f",
//          "text":"Start typing here....DO NOT edit the title or date, please. ",
//          "type":"unstyled",
//          "depth":0,
//          "inlineStyleRanges":[
//
//          ],
//          "entityRanges":[
//
//          ],
//          "data":{
//
//          }
//       },
//       {
//          "key":"49cth",
//          "text":"I've been thinking a lot about how we can use a logic path along with most frequent or probable usage to return the correct items first. \nFor example, you go with the logic that is the most probable. \nisReadingmode? Yes, then reuse this logic down the line as a basis for logic.\n There is a kind of reusable logic path that exists on the determination of one fact that is true.\n You can also see this effect on EditorComponent. ",
//          "type":"unstyled",
//          "depth":0,
//          "inlineStyleRanges":[
//
//          ],
//          "entityRanges":[
//
//          ],
//          "data":{
//
//          }
//       }
//    ],
//    "entityMap":{
//
//    }
// }

    //const compressed = lzwCompress.pack((content));
//console.log(original, original.length);

//console.log("wantToRead", props.wantToRead)
//console.log("wantToEdit",  props.wantToEdit )

    let options = { year: 'numeric', month: 'long', day: 'numeric' };


    if(props.editor === 1) // make mode.
    {


       //this.setState({wantToRead: row.dataentry,wantToReadTitle: row.title, wantToReadDate: row.date.toLocaleDateString("en-US", options), articleMode: true}); break;
      let date = new Date().toLocaleDateString("en-US", options);
      content.blocks[0].text = props.titleInput.current.value;
      content.blocks[1].text = date;
      content.blocks.push({
                  "key": "d812f",
                  "text": original3,
                  "type": "unstyled",
                  "depth": 0,
                  "inlineStyleRanges": [],
                  "entityRanges": [],
                  "data": {}
              })
    }
    if(props.editor === 2)//reading mode
    {
        //THIS LZW ENTRY IS TEMPORARY AND IS REQUIRED TO RESTORE THE LZW ENTRIES AND CONVERT THEM TO THE NEW STYLE ONE BY ONE.
        if(props.entry.lzw || (typeof props.entry.dataentry != 'string' || !(props.entry.dataentry instanceof String)))//is a new type else legacy, careful, legacy wantToRead and new are maybe not the same thing.
        //old style OR PCS
        {
          let temp = props.wantToRead
          temp.blocks[0] = content.blocks[0]
          //console.log(JSON.stringify(content.blocks[0]))
          //console.log(JSON.stringify(content.blocks[1]))
          temp.blocks[0].text = props.entry.title;
          temp.blocks[1] = content.blocks[1]
          temp.blocks[1].text = props.entry.date.toLocaleDateString("en-US", options);
          content = temp;

          //console.log(JSON.stringify(content));
        }
        else {
          console.log("legacy detected, switching")
          content.blocks[1].text = props.entry.date.toLocaleDateString("en-US", options);
          content.blocks[0].text = props.entry.title;
          content.blocks.push({
                      "key": "d812f",
                      "text": props.wantToRead,
                      "type": "unstyled",
                      "depth": 0,
                      "inlineStyleRanges": [],
                      "entityRanges": [],
                      "data": {}
                  })
        }



    }
    if(props.editor === 3)
    {

      try {
        let temp = props.wantToEdit
        temp.blocks[0] = content.blocks[0]
        temp.blocks[0].text = props.titleInput.current.value;
        temp.blocks[1] = content.blocks[1]
        temp.blocks[1].text = props.entry.date.toLocaleDateString("en-US", options);
        content = temp;

      } catch (e) {
        console.log("legacy detected, switching", props.entry, e)
        content.blocks[1].text = props.entry.date.toLocaleDateString("en-US", options);
        content.blocks[0].text = props.entry.title;
        content.blocks.push({
                    "key": "d812f",
                    "text": props.wantToEdit,
                    "type": "unstyled",
                    "depth": 0,
                    "inlineStyleRanges": [],
                    "entityRanges": [],
                    "data": {}
                })
      }
    }

if(savedEditor)
{
  savedEditor.blocks[0] = content.blocks[0];
  savedEditor.blocks[1] = content.blocks[1];
}

    this.state = {
      contentState: savedEditor ? savedEditor : content,
    }

    //savedEditor = false;

  }
  componentDidMount = () => {

  }

  onContentStateChange: Function = (contentState) => {
    this.setState({
      contentState,
    });


  };


  // const MemoedEditor = memo(({ contentState , classes, handleClickOnIndividualNeurotagWhenInsertingNewEntry,editNode, classes }) => {
  //   return (
  //
  //     <div className={((insertingNewEntry) || (editNode)) ? classes.boxForFoundNodes2 : false}>
  //     {filtered_nodes.map(row => (
  //       <Chip
  //     name={row}
  //     label={row}
  //     className={classes.chip}
  //     clickable
  //     color="#5a25de"
  //     onClick={() => handleClickOnIndividualNeurotagWhenInsertingNewEntry(row)}
  //     />
  //          ))}
  //
  //     </div>
  //
  //   )
  // });



  render() {
    const { contentState } = this.state;
    const { classes } = this.props;



    const { editorBackButton, handleClickOpenYTKD} = this.props;



    let irm = this.props.editor === 2;//isreading mode
    return (

      <div className={this.props.mode === 3 ? classes.outerdivEditorComponent: false}>
      <div className={classes.outerDivForBackgroundColor}>
      <div className={classes.outerDivForEditorForMargins}>
        <Editor
        initialContentState={contentState}
        wrapperClassName={classes.wrapper}
        editorClassName={classes.editor}
        onContentStateChange={this.onContentStateChange}
        readOnly = {irm}
        toolbarHidden = {irm}
        />
        <div>
        <div className={classes.classForButtons}>
        {this.props.aM === false ?  <Button variant="contained" color="primary" className={classes.button} onClick={() => editorBackButton(contentState)} >
                 BACK
               </Button> : false}

                      {(irm) ? false : (this.props.editor === 1) ? <div className={classes.submitbuttondiv}><Button variant="contained" color="primary" className={classes.button} onClick={() => {
                        contentState.blocks[0]= {};
                        contentState.blocks[1]= {};
                        this.props.submitNewEntry(contentState)

                      }} >
                               SUBMIT
                             </Button></div> : <Button variant="contained" color="primary" className={classes.button} onClick={() => {

                               contentState.blocks[0]= {};
                               contentState.blocks[1]= {};
                               this.props.editEntry(contentState)
                             }} >
                                      EDIT
                                    </Button>}

                                    {this.props.entry ? (this.props.entry._id.toString() === "60a50cfd3412ea3737d5c77f") ?  <Button variant="contained" color="primary" className={classes.button} onClick={() => handleClickOpenYTKD()} >
                                             CLAIM KARMA
                                           </Button> : false : false}

      </div></div>





      </div>

      </div>
      {this.props.mode === 3 ? <CommentSection dataentryid={this.props.entry._id}/> : false}
      </div>
    );
  }
}

const mapStateToProps = state => {
    return {
    }
  }
const mapDispatchToProps = dispatch => {
    return {
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler( withStyles(styles)(EditorComponent) ));
